import '@babel/polyfill';
import React, { Component } from 'react';
import axios from 'axios';
import ReactDOM from 'react-dom';
import ProductImageSlider from '../../components/ProductImageSlider/ProductImageSlider.js';
import Ellipsis from '../../components/Ellipsis/Ellipsis.js';
import ProductStickyCta from "../../components/ProductStickyCta/ProductStickyCta.js";

let pathName; // pathName for api call
let productSlug; // slug for product
// assign product id
let productId = window.productCourseId ? window.productCourseId : window.productSuiteId;
// assign pathname for api call depending on the product id in the window object
pathName = (window.productSuiteId) ? 'suite-json' : 'course-json';
// assign the slug from the window object
productSlug = window.productSlug;

const getProductData = axios.get('/' + pathName + '/' + productId + '/' + productSlug)
  .then(response => {
    let data;
    data = response;
    renderComponents(data);
  })
  .catch((error) => {
    console.log(error);
  });

function push_analytics(item) {
  let price, type;
  if (item && item.data) {
    if (item.data.course_price) {
      price = item.data.course_price ? item.data.course_price.list_price : '';
      type = "course";
    }
    if (item.data.product_info) {
      price = item.data.product_info ? item.data.product_info.list_price : '';
      type = "certificate";
    }
  }
  if (typeof window !== "undefined" && window.dataLayer && item) {
    window.dataLayer.push({
      event: "view_item",
      ecommerce: {
        currency: "USD",
        value: price,
        items: [
          {
            title: item.data.title,
            brand_name: item.data.brand_name || 'mindedge',
            product_type: type,
            category: item.data.category,
            list_price: price,
          }
        ]
      }
    });
  }
}
/**
  Method that renders components to the DOM 
*/
function renderComponents(data) {
const item = data.data.data;
  push_analytics(item);
  /** Render the Product Description */
  ReactDOM.render(
    <Ellipsis
      maxLine='3'
      contentData={data}
    />,
    document.getElementById('product-description-container')
  );
  /** Render the Product Image Slider */
  ReactDOM.render(
    <ProductImageSlider
      sliderData={data}
    />,
    document.getElementById('product-image-slide-container')
  );

  /** Render the Product Sticky Cta */
  ReactDOM.render(
    <ProductStickyCta
      ctaData={data} />,
    document.getElementById("productStickyCta"));

};